var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 3.0625C16.3586 3.06253 15.2325 3.32527 14.2089 3.83038C13.1853 4.33548 12.2917 5.0694 11.5973 5.9753C10.9029 6.8812 10.4264 7.93477 10.2045 9.05442C9.98267 10.1741 10.0215 11.3298 10.318 12.432L3.0625 19.6875V24.9375H8.3125V22.3125H10.9375V19.6875H13.5625L15.575 17.675C16.2032 17.8465 16.849 17.934 17.5 17.9375C19.4725 17.9375 21.3643 17.1539 22.7591 15.7591C24.1539 14.3643 24.9375 12.4725 24.9375 10.5C24.9375 8.52745 24.1539 6.6357 22.7591 5.24089C21.3643 3.84609 19.4725 3.0625 17.5 3.0625V3.0625Z",
    stroke: "#EFEFEF",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8125 10.0625C19.2957 10.0625 19.6875 9.67075 19.6875 9.1875C19.6875 8.70425 19.2957 8.3125 18.8125 8.3125C18.3293 8.3125 17.9375 8.70425 17.9375 9.1875C17.9375 9.67075 18.3293 10.0625 18.8125 10.0625Z",
    fill: "#EFEFEF",
    stroke: "#EFEFEF",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyIcon);
export default __webpack_public_path__ + "static/media/keyIcon.b603297fa360141483df30ef9f560ad0.svg";
export { ForwardRef as ReactComponent };